import React from "react";
import Fade from "@material-ui/core/Fade";
import Container from "@material-ui/core/Container";
import { BsChevronCompactDown } from "react-icons/bs";
import SearchForm from "./SearchForm";
import styles from "./banner.module.css";
import { useBottomScrollListener } from "react-bottom-scroll-listener";
import { withRouter } from "react-router";

import dealerA640 from "./img/dealer_a_640.png";
import dealerB640 from "./img/dealer_b_640.png";
import dealerA960 from "./img/dealer_a_960.png";
import dealerB960 from "./img/dealer_b_960.png";
import dealerA1280 from "./img/dealer_a_1280.png";
import dealerB1280 from "./img/dealer_b_1280.png";
const timeout = 400;

export default withRouter(({ history }) => {
	const [inState, setInState] = React.useState(true);
	const [imagesLoaded, setImagesLoaded] = React.useState(0);
	const imgStyle = {
		animationPlayState: imagesLoaded === 2 ? "running" : "paused",
	};
	useBottomScrollListener(() => {
		setInState(false);
		window.setTimeout(
			() =>
				history.push(`${process.env.REACT_APP_ROOT_URL}/dealers-list`),
			timeout
		);
	});
	return (
		<Fade in={inState} timeout={timeout}>
			<Container maxWidth="lg">
				<div className={styles.homepageWrapper}>
					<div className={styles.banner}>
						<img
							sizes="50vw"
							onLoad={() => {
								setImagesLoaded(imagesLoaded + 1);
							}}
							style={imgStyle}
							srcSet={`
${dealerA640} 640w,
${dealerA960} 960w,
${dealerA1280}
						`}
							src={dealerA640}
							alt="dealers den banner"
						/>
						<img
							sizes="50vw"
							onLoad={() => {
								setImagesLoaded(imagesLoaded + 1);
							}}
							style={imgStyle}
							srcSet={`
${dealerB640} 640w,
${dealerB960} 960w,
${dealerB1280}
					`}
							src={dealerB640}
							alt="dealers den banner"
						/>
						<h1>Dealers' Den</h1>
					</div>
					<div className={styles.form}>
						<SearchForm />
					</div>
					<div className={styles.or}>
						<span>or</span>
					</div>
					<div className={styles.viewAll}>
						<div>View all</div>
						<div className={styles.viewAllChevvy}>
							<BsChevronCompactDown />
						</div>
					</div>
				</div>
			</Container>
		</Fade>
	);
});
